import { COLORS } from 'constants/colors';
import { useDimensions } from 'hooks/useDimensions';
import { useEffect, useState } from 'react';
import { Icon } from './Icon';

const MAIL = 'cryptunique@gmail.com';

export const AboutContent = () => {
  const [linkCopied, setLinkCopied] = useState(false);

  const { isSmallWidth } = useDimensions();

  useEffect(() => {
    if (linkCopied) {
      setTimeout(() => {
        setLinkCopied(false);
      }, 2000);
    }
  }, [linkCopied]);

  return (
    <>
      <div style={{ height: '100%', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ fontWeight: 300, color: COLORS.white }}>
          <div style={{ marginBottom: 10 }}>
            Hello, we are the <span style={{ fontWeight: 800, color: COLORS.purple }}>Crypto Penis Punk Club</span>.
          </div>
          <div style={{ marginBottom: 10 }}>
            We provide NFT using{' '}
            <span
              style={{ fontWeight: 800, cursor: 'pointer', color: COLORS.purple }}
              onClick={() => {
                window.open('https://opensea.io/', '_blank');
              }}
            >
              opensea
            </span>{' '}
            marketplace.
          </div>
          <div style={{ marginBottom: 10, color: COLORS.white }}>
            Let's keep in touch,{' '}
            <span style={{ fontWeight: 800 }}>
              <a href={`mailto:${MAIL}?subject=Request`} style={{ all: 'unset', cursor: 'pointer', color: COLORS.purple }}>
                {MAIL}
              </a>
            </span>{' '}
            <span>
              (
              <Icon
                style={{ fontSize: 17, cursor: 'pointer', color: COLORS.purple }}
                onClick={() => {
                  navigator.clipboard.writeText(MAIL);
                  setLinkCopied(true);
                }}
              >
                {'file_copy'}
              </Icon>
              )
            </span>{' '}
            is our contact email.
          </div>
        </div>
      </div>
      <div style={{ position: 'absolute', bottom: isSmallWidth ? 30 : 60, left: isSmallWidth ? 30 : 60 }}>
        <div
          style={{
            opacity: linkCopied ? 1 : 0,
            transition: '0.5s',
            padding: '5px 10px',
            backgroundColor: COLORS.purple,
            borderRadius: '5px',
            transform: linkCopied ? 'translate(0)' : 'translate(0px, -50px)',
            '-webkit-box-shadow': '5px -5px 4px 0px rgba(0,0,0,0.44)',
            boxShadow: '5px -5px 4px 0px rgba(0,0,0,0.44)',
            color: COLORS.white,
          }}
        >
          Email copied to the clipboard
        </div>
      </div>
    </>
  );
};
